<template>
  <div :id="this.id">
     
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "DonutsChart",
  props:{
    opcions: Array,
    id: String
  },
  data() {
    return {
      height: 300,
      width: 300
    };
  },
  methods: {    
    generateChart() {
      // set the dimensions and margins of the graph
      var width = 550,
      height = 450,
      margin = 40;

      // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
      var radius = Math.min(width, height) / 2 - margin
      
      // append the svg object to the div called 'pieChart'
      var svg = d3.select("#"+this.id)
        .append("svg")
          .attr("width", width)
          .attr("height", height)
        .append("g")
          .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");
      

      // set the color scale
      var color = d3.scaleOrdinal()
        //.domain(["2", "b", "c", "d", "e", "f", "g", "h"])
        .range(d3.schemeDark2);

      // Compute the position of each group on the pie: 
      var pie = d3.pie()
        .sort(null) // Do not sort group by size
        .value(function(d) {return d.value.percentatge; })
      var slice_elements = pie(d3.entries(this.opcions.filter(o=>o.filtered==false)));
      var filtered_elements = this.opcions.filter(o=>o.filtered==true);


      // The arc generator
      var arc = d3.arc()
        .innerRadius(radius * 0.3)         // This is the size of the donut hole
        .outerRadius(radius * 0.6)

      // Another arc that won't be drawn. Just for labels positioning
      var outerArcBig = d3.arc().innerRadius(radius * 0.85).outerRadius(radius * 0.85)
      var outerArcMedium = d3.arc().innerRadius(radius * 0.715).outerRadius(radius * 0.715)
      var outerArcSmall = d3.arc().innerRadius(radius * 0.60).outerRadius(radius * 0.60)

      // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
      svg
        .selectAll('allSlices')
        .data(slice_elements)
        .enter()
        .append('path')
        .attr('d', arc)
        .attr('fill', function(d){return(color(d.data.key)) })
        .attr("stroke", "white")
        .style("stroke-width", "1px")
        .style("opacity", 0.8)

      var labelPositionsBig = [];
      var labelPositionsSmall = [];
      var labelPositionsMedium = [];

      var labelPositionsType = [];
      
      slice_elements.forEach(function(d) {
            var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2 // we need the angle to see if the X position will be at the extreme right or extreme left
            var posA = arc.centroid(d) // line insertion in the slice

            var posB_Big = outerArcBig.centroid(d) // line break: we use the other arc generator that has been built only for that
            var posC_Big = outerArcBig.centroid(d); // Label position = almost the same as posB            
            posC_Big[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
            labelPositionsBig.push({startAngle: d.startAngle, endAngle: d.endAngle, points: [posA, posB_Big, posC_Big]});

            var posB_Small = outerArcSmall.centroid(d) // line break: we use the other arc generator that has been built only for that
            var posC_Small = outerArcSmall.centroid(d); // Label position = almost the same as posB
            posC_Small[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
            labelPositionsSmall.push({startAngle: d.startAngle, endAngle: d.endAngle, points: [posA, posB_Small, posC_Small]});

            var posB_Medium = outerArcMedium.centroid(d) // line break: we use the other arc generator that has been built only for that
            var posC_Medium = outerArcMedium.centroid(d); // Label position = almost the same as posB
            posC_Medium[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1); // multiply by 1 or -1 to put it on the right or on the left
            labelPositionsMedium.push({startAngle: d.startAngle, endAngle: d.endAngle, points: [posA, posB_Medium, posC_Medium]});
            labelPositionsType.push('b');
          }
      );
      
      svg
        .selectAll('allPolylines')
        .data(slice_elements.reverse())
        .enter()
        .append('polyline')
          .attr("stroke", "black")
          .style("fill", "none")
          .style("opacity", 0.6)
          .attr("stroke-width", 1)
          .attr('points', function(d) {
            
            var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
            var dif = 10;            
            var lastPositionType = 'b';
            var previousIsZero = false;

            //if(!(d.endAngle > 6.28)){ //El primer item de la iteració no enta
            if(!(d.index+1 == slice_elements.length)){ //El primer item de la iteració no enta

                var anterior = slice_elements.filter(a=>a.index == d.index+1)[0];
                var midangleAnterior = anterior.startAngle + (anterior.endAngle - anterior.startAngle) / 2;
                dif = midangleAnterior-midangle;

                lastPositionType=labelPositionsType[d.index+1];

                if(anterior.data.value.percentatge === 0){
                  previousIsZero=true;
                }
            }

            if(previousIsZero && d.data.value.percentatge==0){
              labelPositionsType[d.index]=lastPositionType; 
              return [];
            }else if(dif>0.8){
              labelPositionsType[d.index]='b';            
              return labelPositionsBig[d.index].points;
            }else if(lastPositionType=='b'){              
              labelPositionsType[d.index]='m';              
              return labelPositionsMedium[d.index].points;
            }else{
              labelPositionsType[d.index]='s';              
              return labelPositionsSmall[d.index].points;
            }
            
          })

        // Add labels
        svg
          .selectAll('allLabels')
          .data(slice_elements)
          .enter()
          .append('text')
          .call(text => text.append("tspan")
                        // .attr("y", "-0.4em")                        
                        .attr("y", function(d){
                          var i = 0;

                          if(d.data.value.percentatge === 0 && (d.index+1<slice_elements.length)){
                              var previousIsZero = true;
                              while(previousIsZero){

                                var anterior = slice_elements.filter(a=>a.index == d.index+i+1)[0];
                                if(anterior && anterior.data.value.percentatge === 0){
                                  i++;
                                }else{
                                  previousIsZero = false;
                                }

                              }

                          }
                          
                          return -0.4-(i*1.2)+"em";
                        }                                                
                        )                        
                        .attr("font-size","12")  
                        .attr("font-weight", "bold")
                        .attr("fill-opacity", 0.8)                                                
                        .text(d => d.data.value.opcio.descripcio.text)
                        )                      
          .attr('transform', function(d) {


            var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
            var dif = 10;            
            var lastPositionType = 'b';
            var previousIsZero = false;

            //if(!(d.endAngle > 6.28)){ //El primer item de la iteració no entra
            if(!(d.index+1 == slice_elements.length)){
                var anterior = slice_elements.filter(a=>a.index == d.index+1)[0];
                var midangleAnterior = anterior.startAngle + (anterior.endAngle - anterior.startAngle) / 2;
                dif = midangleAnterior-midangle;
                lastPositionType=labelPositionsType[d.index+1];
                if(anterior.data.value.percentatge === 0){
                  previousIsZero=true;
                }
            }


            var pos = labelPositionsBig[d.index].points[1];
            if(previousIsZero && d.data.value.percentatge==0){
              pos = labelPositionsBig[d.index].points[1];
            }else if(dif>0.8){
              pos = labelPositionsBig[d.index].points[1];
            }else if(lastPositionType=='b'){
              pos = labelPositionsMedium[d.index].points[1];
            }else{
              pos = labelPositionsSmall[d.index].points[1];
            }


                pos[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1);                                
                return 'translate(' + pos + ')';
          })
          .style('text-anchor', function(d) {
                var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
                return (midangle < Math.PI ? 'start' : 'end')
          })


        // Add percentatges
        svg
          .selectAll('allPercentatges')
          .data(slice_elements)
          .enter()
          .append('text')                  
          .call(text => text.append("tspan")
                        .attr("x", 0)
                        .attr("y", "0.7em")
                        .attr("font-size","12") 
                        .attr("fill-opacity", 0.7)
                        .text(d => " "+d.data.value.percentatge+"%")
                        )
          .attr('transform', function(d) {


            var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
            var dif = 10;            
            var lastPositionType = 'b';
            var previousIsZero = false;

            //if(!(d.endAngle > 6.28)){ //El primer item de la iteració no enta
            if(!(d.index+1 == slice_elements.length)){
                var anterior = slice_elements.filter(a=>a.index == d.index+1)[0];
                var midangleAnterior = anterior.startAngle + (anterior.endAngle - anterior.startAngle) / 2;
                dif = midangleAnterior-midangle;
                lastPositionType=labelPositionsType[d.index+1];
                if(anterior.data.value.percentatge === 0){
                  previousIsZero=true;
                }
            }


            var pos = labelPositionsBig[d.index].points[1];
            if(previousIsZero && d.data.value.percentatge==0){
              pos = labelPositionsBig[d.index].points[1];
            }else if(dif>0.8){
              pos = labelPositionsBig[d.index].points[1];
            }else if(lastPositionType=='b'){
              pos = labelPositionsMedium[d.index].points[1];
            }else{
              pos = labelPositionsSmall[d.index].points[1];
            }


                pos[0] = radius * 0.95 * (midangle < Math.PI ? 1 : -1);
                return 'translate(' + pos + ')';
          })
          .style('text-anchor', function(d) {
                var midangle = d.startAngle + (d.endAngle - d.startAngle) / 2
                return (midangle < Math.PI ? 'start' : 'end')
          })

          var filteredLabIndex = 0;
          svg
          .selectAll('allFiltered')
          .data(filtered_elements)
          .enter()
          .append('text')
          .call(text => text.append("tspan")
                        .attr("y", "0")
                        .attr("font-weight", "bold")
                        .attr("font-size","12")  
                        .attr("font-weight", "bold")
                        .attr("fill-opacity", 0.8)                             
                        .text(function(d){
                            return d.opcio.descripcio.text+':';
                        }))
          .call(text => text.append("tspan")                        
                        .attr("y", 0)
                        .attr("font-size","12") 
                        .attr("fill-opacity", 0.7)
                        .text(d => " "+d.count)
                        )                        
           .attr('transform', function() {
             filteredLabIndex++;
             return 'translate(30,'+(180 + 20*filteredLabIndex)+')';
           });


    }

  }, 
  mounted() {    
    this.generateChart();
  }
};
</script>

<style>
</style>